import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import Ripple from 'vuetify/lib/directives/ripple';
import preset from './default-preset/preset'

import store from '@/store'
import pt from 'vuetify/lib/locale/pt'

import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'

import { SYSTEM, DARK } from "@/store/mutation-types";

import Color from 'color';

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
})

export const vuetifyConfig = {
  preset,

  lang: {
    locales: { pt },
    current: 'pt',
  },

  icons: {
    iconfont: 'mdi',
  },

  // breakpoint: {
  //   mobileBreakpoint: 'sm'
  // },

  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
    dark: store.state[SYSTEM][DARK] || true
  },
}

export function customizeThemes(customThemes) {
  const themes = vuetifyConfig.preset.theme.themes

  if (customThemes.light) themes.light = customThemes.light;
  if (customThemes.dark) themes.dark = customThemes.dark;

  if (themes.light.background) {
    themes.light['background-lighter'] = lightenColor(themes.light.background, 0.3);
    themes.light['background-darker'] = darkenColor(themes.light.background, 0.3);
  }

  if (themes.dark.background) {
    themes.dark['background-lighter'] = lightenColor(themes.dark.background, 0.3);
    themes.dark['background-darker'] = darkenColor(themes.dark.background, 0.3);
  }
}

function lightenColor(colorValue, amount) {
  return Color(colorValue).lighten(amount).hex();
}

function darkenColor(colorValue, amount) {
  return Color(colorValue).darken(amount).hex();
}
